<template>
  <transition name="dropdown-content">
    <div v-if="active" class="origin-top-right menu absolute text-left mt-2 bg-white rounded-lg border"
      :class="classes">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  name: "AppDropdownContent",
  props: {
    autoWidth: {
      type: Boolean,
      default: false,
    },
    contentClasses: {
      type: String,
      default: ""
    }
  },
  inject: ["sharedState"],
  computed: {
    active() {
      return this.sharedState.active;
    },
    classes() {
      return this.autoWidth
        ? "autoWidth unsetPadding " + this.contentClasses
        : "w-48";
    },
  },
};
</script>

<style scoped>
.dropdown-content-enter-active,
.dropdown-content-leave-active {
  transition: all 0.2s;
}

.dropdown-content-enter,
.dropdown-content-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

.menu {
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.menu::-webkit-scrollbar {
  display: none;
}
</style>